import http from "./httpService";

const endPoint = "/api/v1/CostAccountingMovement";

export function getCostMov(request) {
    return http.post(`${endPoint}`, request);
}

export default {getCostMov};


// WEBPACK FOOTER //
// ./src/services/costAccountingMovService.js